export default __webpack_public_path__ + "59782cbb103452238108334f3d0401a4.png";